import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { name: 'About DDA', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Events', path: '/events' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <footer className="bg-[#1A2332] text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/logo.png" 
                alt="Hiri Koiari District" 
                className="w-14 h-14 rounded-full object-cover"
              />
              <h3 className="text-xl font-bold text-white">Hiri Koiari DDA</h3>
            </div>
            <p className="text-gray-400 leading-relaxed text-sm">
              Working together to build sustainable development and improved services for all
              residents of Hiri Koiari District.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors duration-200 inline-block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">Mirigeda, Central Province, PNG</span>
              </div>
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">Phone: 82145459</span>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">Email: info.hk@hirikoiari.central.gov.pg</span>
              </div>
            </div>
          </div>

          {/* Member Section */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white">Our Member</h3>
            <div className="flex flex-col items-center">
              <img 
                src="/member.jpg" 
                alt="Honourable Keith Iduhu - Member for Hiri-Koiari" 
                className="w-32 h-32 rounded-full object-cover border-4 border-yellow-500 shadow-lg"
              />
              <div className="mt-3 text-center">
                <p className="text-white font-semibold">Hon. Keith Iduhu</p>
                <p className="text-gray-400 text-xs">LLB, MP</p>
                <p className="text-yellow-500 text-xs font-medium">Member for Hiri-Koiari</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Hiri Koiari District Development Authority. All rights reserved.
          </p>
          <div className="flex items-center space-x-4">
            <img 
              src="/logo.png" 
              alt="Hiri Koiari District" 
              className="w-10 h-10 rounded-full object-cover"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;